import { render } from "./userAnalyseReport.vue?vue&type=template&id=5e87b5a1&scoped=true"
import script from "./userAnalyseReport.vue?vue&type=script&lang=js"
export * from "./userAnalyseReport.vue?vue&type=script&lang=js"

import "./userAnalyseReport.vue?vue&type=style&index=0&id=5e87b5a1&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e87b5a1"]])

export default __exports__